import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { QuotationTemplatesPage } from '@/areas/quotations/QuotationTemplates/QuotationTemplatesPage';
import { canViewQuotationTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/templates/quotation/')({
    staticData: { access: { permissions: canViewQuotationTemplates }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <QuotationTemplatesPage />;
}
